import {
    SparePartGroupList,
    SparePartsResponseError,
} from '@ecs-features/result/spare-parts-result/spare-parts.interface';
import { Reconstruction } from '@ecs-services/product-reconstruction.service';
import { createAction, props } from '@ngrx/store';
import { PackageInformation } from '@os-components';
import { PartsRecommendation } from 'src/app/components/parts-recommendation/parts-recommendation.interface';
import {
    DriveGroupsWithSparePartsWear,
    SparePartWithAvailability,
} from '../../../../services/spare-part/spare-part.service';
import { prefixed } from '../../../store.helper';

const prefix = '[Serial No. Result]';

export const RECEIVE_PRODUCT_PICTURE = prefixed(prefix, 'Receive product picture');
export const receiveProductPicture = createAction(
    RECEIVE_PRODUCT_PICTURE,
    props<{ payload: { pictureUrl: string } }>()
);

export const RECEIVE_SPARE_PARTS = prefixed(prefix, 'Receive spare parts');
export const receiveSpareParts = createAction(
    RECEIVE_SPARE_PARTS,
    props<{ payload: { spareParts: SparePartGroupList } }>()
);

export const RECEIVE_SPARE_PARTS_ERROR = prefixed(prefix, 'Receive spare parts (ERROR)');
export const receiveSparePartsError = createAction(
    RECEIVE_SPARE_PARTS_ERROR,
    props<{ payload: { sparePartsError: SparePartsResponseError } }>()
);

export const RECEIVE_SPARE_PARTS_AVAILABILITY = prefixed(prefix, 'Receive spare parts availability');
export const receiveSparePartsAvailability = createAction(
    RECEIVE_SPARE_PARTS_AVAILABILITY,
    props<{ payload: { sparePartsWithAvailability: SparePartWithAvailability[] } }>()
);

export const RECEIVE_SPARE_PARTS_WEAR = prefixed(prefix, 'Receive spare parts wear');
export const receiveSparePartsWear = createAction(
    RECEIVE_SPARE_PARTS_WEAR,
    props<{ payload: { sparePartsWithWear: DriveGroupsWithSparePartsWear } }>()
);

export const RECEIVE_PRODUCT_LIFE_CYCLE_STATUS = prefixed(prefix, 'Receive product life cycle status');
export const receiveProductLifeCycleStatus = createAction(
    RECEIVE_PRODUCT_LIFE_CYCLE_STATUS,
    props<{ payload: { productLifeCycleStatus: string } }>()
);

export const RECEIVE_SPARE_PART_RECOMMENDATIONS = prefixed(prefix, 'Receive spare part recommendations');
export const receiveSparePartRecommendations = createAction(
    RECEIVE_SPARE_PART_RECOMMENDATIONS,
    props<{ payload: { recommendations: PartsRecommendation[] } }>()
);

export const RECEIVE_PRODUCT_RECONSTRUCTION_STATUS = prefixed(
    prefix,
    'Receive product reconstruction status'
);
export const receiveProductReconstructionStatus = createAction(
    RECEIVE_PRODUCT_RECONSTRUCTION_STATUS,
    props<{ payload: { reconstruction: Reconstruction } }>()
);

export const RECEIVE_PRODUCT_PACKAGE_INFORMATION = prefixed(prefix, 'Receive product package information');
export const receiveProductPackageInformation = createAction(
    RECEIVE_PRODUCT_PACKAGE_INFORMATION,
    props<{ payload: { packageInformation: PackageInformation | null } }>()
);
